import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // Enhanced error handling for token refresh
    flowType: 'pkce',
    storage: window?.localStorage,
    storageKey: 'supabase.auth.token',
  },
  global: {
    headers: {
      'X-Client-Info': 'corperconnect-web',
    },
  },
});

// Add global error handler for auth errors
supabase?.auth?.onAuthStateChange((event, session) => {
  if (event === 'TOKEN_REFRESH_FAILED') {
    console.warn('Token refresh failed - user will need to sign in again');
    // The AuthContext will handle cleanup
  }
});